<template>
  <div class="Create alignment">
    <template>
      <v-layout>
        <v-flex xs12 sm6 sm4 style="padding-right: 6px">
          <h3 v-if="checkEdit" class="styleHeader">
            {{ $t("pages.Extractions.Create.EstrazioneDuplica") }}
          </h3>
          <h3 v-else-if="edit" class="styleHeader">
            {{ $t("pages.Extractions.Create.EstrazioneModifica") }}
          </h3>
          <h3 v-else class="styleHeader">
            {{ $t("pages.Extractions.Create.EstrazioneAggiungi") }}
          </h3>
          <v-card class="styleDataTable">
            <form>
              <v-text-field
                v-model="name"
                :label="$t('pages.Extractions.Create.LabelNome')"
                :error-messages="nameErrors"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
              ></v-text-field>
              <v-select
                v-model="categorySelected"
                :items="category"
                :label="$t('pages.Extractions.Create.LabelSelezionaCategoria')"
                item-text="description"
                item-value="id"
                required
                :error-messages="categorySelectedErrors"
                @change="$v.categorySelected.$touch()"
                @blur="$v.categorySelected.$touch()"
              ></v-select>
              <v-textarea
                v-model="query"
                :label="$t('pages.Extractions.Create.LabelQuery')"
                :error-messages="queryErrors"
                @input="$v.query.$touch()"
                @blur="$v.query.$touch()"
              ></v-textarea>
            </form>
          </v-card>
          <v-btn
            class="white--text styleButtonTop styleAlignementSaveButton"
            @click="submit"
            color="#279947"
          >
            <v-icon left>check_circle</v-icon>
            {{ $t("pages.Extractions.Create.Salva") }}
          </v-btn>
          <v-btn class="styleButtonTop" @click="back()">
            <v-icon left>remove_circle</v-icon>
            {{ $t("pages.Extractions.Create.Annulla") }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 sm4 style="padding-top: 62px; padding-left: 6px">
          <v-card class="styleDataTable" style="margin: 15px">
            <v-card-title primary-title>
              <div>
                <h4 style="margin-top: -20px">
                  {{ $t("pages.Extractions.Create.Legenda") }}
                </h4>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">[cmp_text="Testo laterale"]:</span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.StringTestoLaterale")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">[cmp_check="Testo laterale"]:</span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.BoolTestoLaterale")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">[cmp_datetime="Testo laterale"]:</span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.DateTimeTestoLaterale")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">
                      [cmp_dropdown="Testo laterale","Text Option 1;Value
                      1","Text Option 2;Value 2"]:
                    </span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.ListOption1Value1")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">[cmp_clients="Testo laterale"]:</span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.ListCustomer")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">[db_selector]:</span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.DatabaseTable")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">
                      <h4 class="styleLegend">
                        {{ $t("pages.Extractions.Create.Convenzioni") }}:
                      </h4>
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">as IDCODSOC:</span>
                  </v-flex>
                  <v-flex xs6>{{
                    $t("pages.Extractions.Create.codSocFilter")
                  }}</v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">
                      <h4 class="styleLegend">
                        {{ $t("pages.Extractions.Create.Esempio") }}:
                      </h4>
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <span class="body-2">
                      select
                      <br />top 100 art.bat_codart, art.bat_codsoc,
                      bcode.bdd_utente <br />from <br />BANTARTIC as art inner
                      join BANBARCOD as bcode on bcode.bdd_codart =
                      art.bat_codart <br />where <br />bcode.bdd_utente =
                      [cmp_text="utente"] and <br />art.bat_codsoc =
                      [cmp_clients="Clienti"] order by art.bat_codart
                      <br />
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">
                      <h4 class="styleLegend">
                        {{ $t("pages.Extractions.Create.Filtri") }}:
                      </h4>
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <span class="body-2">
                      Per associare il tipo filtro alla colonna bisogna utilizzare la convenzione <i>campo as nome_completo__tipo.</i><br/>
                      Modalità d'uso: <br/>
                       &nbsp; •  per visualizzare uno spazio per il nome colonna utilizzare un singolo underscore (i.e. _).<br/>
                       &nbsp; •  per la definizione del tipo dato, utilizzare il doppio underscore (i.e. __); i tipi dato disponibili sono: <br/>
                       &nbsp;&nbsp;&nbsp; <strong> string, boolean, numeric e date. </strong><br/>
                       &nbsp; •  inoltre per utilizzo del tipo dato "date", il campo deve essere formattato utilizzando la funzione SQL FORMAT(field, 'yyyy-MM-dd').
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <span class="body-2">
                      <h5 class="styleLegend" style="margin-top:15px;">
                        {{ $t("pages.Extractions.Create.Esempio") }}:
                      </h5>
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <span class="body-2">
                      es1. <i>campo as Numero_Ordine__numeric</i> = colonna denominata "Numero Ordine" di tipo Numeric. <br/>
                      es2. <i>FORMAT(Data_Ordine, 'yyyy-MM-dd') as Data_Ordine__date</i> = colonna denominata "Data Ordine" di tipo Date. <br/>
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">{{
        errorMessage
      }}</v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import extractionCategoryApi from "../../apiSmartLogistics/extractionCategoryApi.js";
import extractionApi from "../../apiSmartLogistics/extractionApi.js";
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
export default {
  mixins: [validationMixin],
  validations: {
    categorySelected: { required },
    name: { required },
    query: { required }
  },

  data: () => ({
    categorySelected: "",
    category: [],
    query: "",
    name: "",
    errorAlert: false,
    errorMessage: "",
    refreshMenu: ""
  }),

  computed: {
    edit() {
      return this.$route.params.id;
    },

    checkEdit() {
      return this.$route.params.duplicate;
    },

    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },
    categorySelectedErrors() {
      const errors = [];
      if (!this.$v.categorySelected.$dirty) return errors;
      !this.$v.categorySelected.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },

    queryErrors() {
      const errors = [];
      if (!this.$v.query.$dirty) return errors;
      !this.$v.query.required &&
        errors.push(this.i18n.t("Validations.CampoObbligatorio"));
      return errors;
    },
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    },
    i18n() {
      return Trans.i18n;
    }
  },

  created() {
    const id = this.$route.params.id;

    if (id) {
      extractionApi.GetExtraction(id).then(response => {
        this.id = response.data.id;
        this.categorySelected = response.data.idCategory;
        this.name = response.data.name;
        this.query = response.data.queryCustom;

        // duplicate case, rename the extraction
        if (this.$route.params.duplicate) {
          this.name = this.name + "_1";
        }
      });
    }

    this.getCategories();
  },

  methods: {
    getCategories() {
      extractionCategoryApi.GetExtractionsCategories().then(response => {
        this.category = response.data;
      });
    },

    back() {
      router.push("/" + this.currentLanguage + "/Extractions/Index");
    },
    submit() {
      this.$v.$touch();
      let route_id = this.$route.params.id;

      // duplicate case, remove id
      if (this.$route.params.duplicate) {
        route_id = undefined;
        //this.name = this.name + "_1";
      }
      if (
        this.$v.name.$error ||
        this.$v.query.$error ||
        this.$v.categorySelected.$error
      ) {
        return;
      }

      let extraction = {
        id: route_id,
        name: this.name,
        idCategory: this.categorySelected,
        queryCustom: this.query
      };

      if (route_id) {
        extractionApi
          .UpdateExtraction(extraction)
          .then(() => {
            this.$emit("refreshMenu", this.refreshMenu);
            router.push("/" + this.currentLanguage + "/Extractions/Index");
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      } else {
        extractionApi
          .AddExtraction(extraction)
          .then(() => {
            router.push("/" + this.currentLanguage + "/Extractions/Index");
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
      }
    },
    clear() {
      this.$v.$reset();
      this.categorySelected = "";
      this.name = "";
      this.query = "";
    }
  }
};
</script>
